import { createClient } from '@supabase/supabase-js';

import type { Database } from './database.types.js';
import { browserAuthOptions } from './supabaseOptions.js';

const configuredUrl: unknown = import.meta.env.VITE_SUPABASE_URL;
const configuredAnonKey: unknown = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (
  typeof configuredUrl !== 'string' ||
  configuredUrl === '' ||
  typeof configuredAnonKey !== 'string' ||
  configuredAnonKey === ''
) {
  throw new Error(
    'Missing Supabase client configuration. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.',
  );
}

/**
 * The one browser client. Supabase owns persistence and refresh-token rotation;
 * every data request made through this instance automatically carries the
 * current user session and is constrained by Postgres RLS.
 */
export const supabase = createClient<Database>(configuredUrl, configuredAnonKey, {
  auth: browserAuthOptions,
});
